
const setObjectValue = (idArray, obj, value) => {
	const id = idArray.shift();
	if(idArray.length > 0){
		let subObj = setObjectValue(idArray, obj[id], value);
		obj[id] = subObj;
		return obj;
	} else {
		obj[id] = value;
		return obj;
	}
}

export default (id, obj, value) => {
	if(id === undefined) return;
	let idArray = id.split('.')
	setObjectValue(idArray, obj, value);
};